// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"3cd3847a","787":"0b44a36f"}[chunkId] + ".chunk.js";
};